import React, { useEffect, useState } from 'react';
import { CheckCircle2, ShieldCheck, Lock, CreditCard, ArrowRight, Star, Calendar, Gamepad2, Zap } from 'lucide-react';
type PackChoice = 'profesional' | 'elite';
const CHECKOUT_URLS: Record<PackChoice, string> = {
  profesional: 'https://profelisto.com.ar/checkouts/cn/hWNCutEZaBHOWH7pFBF6GmGY/es-ar?_r=AQAB6wc27AhYKrbGBOG0lNBAEU0-pmzM_O6r-5Gj0p7pi-4',
  elite: 'https://profelisto.com.ar/checkouts/cn/hWNCutEqOFd1vepZz8kBRTjG/es-ar?_r=AQABfptd6HSysjRDmLVLhO27a3oaD_XEPmNjxvdeX-faZK8'
};
const PACK_PRICES: Record<PackChoice, number> = {
  profesional: 18990,
  elite: 27990
};
export function PricingSection() {
  const [selectedPack, setSelectedPack] = useState<PackChoice>('elite');
  const handleCheckout = () => {
    try {
      if (typeof window !== 'undefined' && (window as any).fbq) {
        ;
        (window as any).fbq('track', 'InitiateCheckout', {
          value: PACK_PRICES[selectedPack],
          currency: 'ARS',
          content_name: selectedPack === 'elite' ? 'Megapack Élite PADEL 360' : 'Pack Profesional PADEL 360'
        });
      }
    } catch (_) {
      /* swallow */
    }
    window.location.href = CHECKOUT_URLS[selectedPack];
  };
  // Countdown Timer Logic
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 37
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSecs = prev.seconds - 1;
        let newMins = prev.minutes;
        let newHours = prev.hours;
        if (newSecs < 0) {
          newSecs = 59;
          newMins -= 1;
        }
        if (newMins < 0) {
          newMins = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMins,
          seconds: newSecs
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div id="pricing" className="w-full bg-slate-50 scroll-mt-10" data-id="element-122">
      {/* SECTION 7 - PRECIO Y OFERTA */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-123">
        <div className="text-center mb-12" data-id="element-124">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-slate-900 mb-8 uppercase" data-id="element-125">
            ⏰ PRECIO DE LANZAMIENTO — OFERTA POR TIEMPO LIMITADO
          </h2>

          {/* Countdown */}
          <div className="flex justify-center gap-4 md:gap-8 mb-6" data-id="element-126">
            <TimeUnit value={timeLeft.hours} label="HS" data-id="element-127" />
            <div className="text-4xl font-bold text-slate-400 mt-2" data-id="element-128">:</div>
            <TimeUnit value={timeLeft.minutes} label="MIN" data-id="element-129" />
            <div className="text-4xl font-bold text-slate-400 mt-2" data-id="element-130">:</div>
            <TimeUnit value={timeLeft.seconds} label="SEG" data-id="element-131" />
          </div>

          <p className="text-red-600 font-bold text-lg mb-8 animate-pulse" data-id="element-132">
            🔴 El precio sube cuando termina el contador
          </p>
        </div>

        {/* CHECKOUT CARD */}
        <div className="max-w-xl mx-auto bg-white rounded-3xl p-6 sm:p-10 shadow-xl border border-slate-100" data-id="element-133">
          <div className="text-center mb-8" data-id="element-134">
            <h3 className="text-3xl sm:text-4xl font-heading font-bold text-slate-900 mb-3" data-id="element-135">
              Elegí tu Pack:
            </h3>
            <p className="text-slate-500 text-base sm:text-lg font-medium" data-id="element-136">
              Ambas opciones incluyen los 6 Bonus estratégicos
            </p>
          </div>

          <div className="space-y-4 mb-6" data-id="element-137">
            {/* Pack Profesional Row */}
            <PackOption selected={selectedPack === 'profesional'} onClick={() => setSelectedPack('profesional')} emoji="📘" title="PACK PROFESIONAL" subtitle="12 Tomos + 6 Bonus" oldPrice="$29.990" newPrice="$18.990" data-id="element-138" />

            {/* Megapack Élite Row */}
            <PackOption selected={selectedPack === 'elite'} onClick={() => setSelectedPack('elite')} emoji="🏆" title="MEGAPACK ÉLITE" subtitle="12 Tomos + 6 Bonus + 2 EBOOKS ÉLITE" oldPrice="$49.990" newPrice="$27.990" badges={<div className="flex flex-wrap items-center gap-2 mt-2 mb-1" data-id="element-140">
                  <span className="inline-flex items-center gap-1.5 bg-amber-400 text-amber-950 font-bold text-xs px-3 py-1 rounded-full" data-id="element-141">
                    <Star className="w-3.5 h-3.5 fill-current" data-id="element-142" /> MÁS ELEGIDO
                  </span>
                  <span className="inline-flex items-center bg-orange-100 text-orange-700 font-bold text-xs px-3 py-1 rounded-full" data-id="element-143">
                    AHORRÁS $22.000
                  </span>
                </div>} data-id="element-139" />
          </div>

          {/* Single Dynamic CTA */}
          <button onClick={handleCheckout} className="w-full bg-orange-500 hover:bg-orange-600 text-white text-lg sm:text-xl font-heading font-bold py-5 px-6 rounded-2xl shadow-lg shadow-orange-500/30 transition-all hover:scale-[1.02] flex items-center justify-center gap-3 uppercase tracking-wide" data-id="element-144">
            {selectedPack === 'elite' ? 'SÍ, QUIERO EL MEGAPACK ÉLITE' : 'QUIERO EL PACK PROFESIONAL'}
            <ArrowRight className="w-5 h-5" data-id="element-145" />
          </button>

          {selectedPack === 'elite' && <p className="text-center text-slate-500 text-sm italic mt-6" data-id="element-146">
              La opción más elegida por profesores de pádel argentinos
            </p>}
        </div>

        {/* Trust badges grid */}
        <div className="max-w-xl mx-auto mt-10 grid grid-cols-2 gap-x-6 gap-y-4 text-slate-600 text-sm font-medium" data-id="element-147">
          <span className="flex items-center gap-2" data-id="element-148">
            <Lock className="w-5 h-5 text-slate-500" data-id="element-149" /> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-150">
            <Zap className="w-5 h-5 text-amber-500" data-id="element-151" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-2" data-id="element-152">
            <ShieldCheck className="w-5 h-5 text-emerald-600" data-id="element-153" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2" data-id="element-154">
            <CreditCard className="w-5 h-5 text-slate-500" data-id="element-155" /> Tarjeta ·
            Transferencia
          </span>
        </div>
      </section>

      {/* SECTION 8 - QUÉ AGREGA EL MEGAPACK ÉLITE */}
      <section className="py-16 bg-white px-4 sm:px-6 lg:px-8 border-t border-slate-200" data-id="element-156">
        <div className="max-w-5xl mx-auto" data-id="element-157">
          <div className="text-center mb-12" data-id="element-158">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-slate-900 mb-4" data-id="element-159">
              ¿Qué agrega el Megapack Élite?
            </h2>
            <p className="text-xl text-slate-600 font-medium" data-id="element-160">
              Por solo $9.000 más, resolvés tu año de clases completo.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-161">
            <div className="bg-yellow-50 border border-yellow-200 rounded-2xl p-8" data-id="element-162">
              <div className="flex items-center gap-4 mb-6" data-id="element-163">
                <div className="bg-yellow-400 p-3 rounded-xl text-slate-900" data-id="element-164">
                  <Calendar className="w-6 h-6" data-id="element-165" />
                </div>
                <h3 className="text-xl font-heading font-bold text-slate-900" data-id="element-166">
                  Élite 1 — El Programador Maestro (365 días)
                </h3>
              </div>
              <p className="text-slate-700 leading-relaxed font-medium" data-id="element-167">
                Tu calendario de ENERO a DICIEMBRE ya está armado. Semana a
                semana, tomo por tomo, evaluación por evaluación. Nunca más el
                domingo a la noche sin saber qué dar el lunes.
              </p>
            </div>

            <div className="bg-yellow-50 border border-yellow-200 rounded-2xl p-8" data-id="element-168">
              <div className="flex items-center gap-4 mb-6" data-id="element-169">
                <div className="bg-yellow-400 p-3 rounded-xl text-slate-900" data-id="element-170">
                  <Gamepad2 className="w-6 h-6" data-id="element-171" />
                </div>
                <h3 className="text-xl font-heading font-bold text-slate-900" data-id="element-172">
                  Élite 2 — La Biblia de las Variantes
                </h3>
              </div>
              <p className="text-slate-700 leading-relaxed font-medium" data-id="element-173">
                +100 micro-variantes para que ninguna clase se parezca a la
                anterior. Gamificación, sistemas de puntaje y drills de rescate
                para cuando el grupo está con mala energía.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 9 - TABLA COMPARATIVA */}
      <section className="py-20 bg-slate-900 text-white px-4 sm:px-6 lg:px-8" data-id="element-174">
        <div className="max-w-5xl mx-auto" data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-center mb-12" data-id="element-176">
            ¿Cuánto cuesta NO tenerlo?
          </h2>

          <div className="overflow-x-auto pb-6" data-id="element-177">
            <table className="w-full min-w-[600px] border-collapse" data-id="element-178">
              <thead data-id="element-179">
                <tr data-id="element-180">
                  <th className="w-1/3 p-4 text-left text-slate-400 font-medium border-b border-slate-700" data-id="element-181"></th>
                  <th className="w-1/3 p-4 text-center text-red-400 font-bold text-xl border-b border-slate-700" data-id="element-182">
                    Sin PADEL 360
                  </th>
                  <th className="w-1/3 p-4 text-center text-emerald-400 font-bold text-xl border-b border-slate-700 bg-emerald-900/20 rounded-t-xl" data-id="element-183">
                    Con PADEL 360
                  </th>
                </tr>
              </thead>
              <tbody className="text-lg" data-id="element-184">
                <TableRow label="Planificación semanal" bad="2 horas armando desde cero" good="5 minutos. Todo listo." data-id="element-185" />
                <TableRow label="Drills y secuencias" bad="Improvisados sin progresión" good="+120 secuencias graficadas por nivel" data-id="element-186" />
                <TableRow label="Grupos mixtos" bad="Sin sistema claro" good="Estructura para cada nivel y objetivo" data-id="element-187" />
                <TableRow label="Alumnos con lesiones" bad="Miedo a equivocarte" good="Protocolos listos para usar" data-id="element-188" />
                <TableRow label="El domingo a la noche" bad="Ansiedad y estrés" good="Planilla maestra en 15 minutos" data-id="element-189" />
                <TableRow label="Progreso del alumno" bad="No se ve, no se mide" good="Checklist de graduación por tomo" data-id="element-190" />
                <TableRow label="Fidelidad del alumno" bad="Se va a los 3 meses" good="Se queda todo el año con un plan" isLast data-id="element-191" />
              </tbody>
            </table>
          </div>

          <div className="text-center mt-12" data-id="element-192">
            <p className="text-2xl font-heading font-bold text-yellow-400 italic" data-id="element-193">
              "El lunes podés improvisar o entrar con todo resuelto. Vos
              decidís."
            </p>
          </div>
        </div>
      </section>
    </div>;
}
function TimeUnit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-194">
      <div className="bg-slate-900 text-white text-4xl md:text-5xl font-heading font-bold w-20 h-20 md:w-24 md:h-24 flex items-center justify-center rounded-2xl shadow-inner border border-slate-700" data-id="element-195">
        {value.toString().padStart(2, '0')}
      </div>
      <span className="text-slate-500 font-bold text-sm mt-2 tracking-wider" data-id="element-196">
        {label}
      </span>
    </div>;
}
function TableRow({
  label,
  bad,
  good,
  isLast = false
}: {
  label: string;
  bad: string;
  good: string;
  isLast?: boolean;
}) {
  return <tr data-id="element-197">
      <td className={`p-5 text-slate-300 font-medium ${!isLast ? 'border-b border-slate-800' : ''}`} data-id="element-198">
        {label}
      </td>
      <td className={`p-5 text-center text-slate-400 ${!isLast ? 'border-b border-slate-800' : ''}`} data-id="element-199">
        {bad}
      </td>
      <td className={`p-5 text-center text-emerald-300 font-bold bg-emerald-900/20 ${!isLast ? 'border-b border-emerald-900/50' : 'rounded-b-xl'}`} data-id="element-200">
        <div className="flex items-center justify-center gap-2" data-id="element-201">
          <CheckCircle2 className="w-5 h-5 text-emerald-500" data-id="element-202" /> {good}
        </div>
      </td>
    </tr>;
}
function PackOption({
  selected,
  onClick,
  emoji,
  title,
  subtitle,
  oldPrice,
  newPrice,
  badges
}: {
  selected: boolean;
  onClick: () => void;
  emoji: string;
  title: string;
  subtitle: string;
  oldPrice: string;
  newPrice: string;
  badges?: React.ReactNode;
}) {
  return <button type="button" onClick={onClick} className={`w-full text-left rounded-2xl border-2 transition-all p-5 sm:p-6 flex items-start gap-4 ${selected ? 'border-orange-400 bg-orange-50/60 shadow-md' : 'border-slate-200 bg-white hover:border-slate-300'}`} data-id="element-203">
      {/* Radio */}
      <div className="pt-1 flex-shrink-0" data-id="element-204">
        <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${selected ? 'border-orange-500' : 'border-slate-300'}`} data-id="element-205">
          {selected && <div className="w-3 h-3 rounded-full bg-orange-500" data-id="element-206"></div>}
        </div>
      </div>

      {/* Title block */}
      <div className="flex-1 min-w-0" data-id="element-207">
        <div className="flex items-start gap-2 mb-1" data-id="element-208">
          <span className="text-2xl leading-none" data-id="element-209">{emoji}</span>
          <h4 className="text-lg sm:text-xl font-heading font-bold text-slate-900 leading-tight uppercase" data-id="element-210">
            {title}
          </h4>
        </div>
        {badges}
        <p className="text-slate-500 text-sm sm:text-base font-medium mt-1" data-id="element-211">
          {subtitle}
        </p>
      </div>

      {/* Price block */}
      <div className="text-right flex-shrink-0" data-id="element-212">
        <p className="text-slate-400 line-through text-sm font-medium" data-id="element-213">
          {oldPrice}
        </p>
        <p className={`text-2xl sm:text-3xl font-heading font-bold ${selected ? 'text-orange-600' : 'text-slate-900'}`} data-id="element-214">
          {newPrice}
        </p>
      </div>
    </button>;
}